import activity from './activity'
import store from './store'
import user from './wx'
import order from './order'
import busCoupon from './busCoupon'

export default {
  activity,
  store,
  user,
  order,
  busCoupon
}
